import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import PipelineFilter from './PipelineFilter';
import { downCarrot } from '../library/Svgs';
import OrganizationListItem from './OrganizationListItem';
import axios from 'axios';

class OrganizationsApp extends Component {
  constructor(props) {
    super(props);

    this.setCurrentStage = this.setCurrentStage.bind(this);
    this.setView = this.setView.bind(this);
    this.state = {
      view: 'grid',
      currentStage:
        (((this.props || {}).match || {}).params || {}).stage ||
        ((this.props || {}).currentStage || 'all'),
    };
  }

  setCurrentStage(stage) {
    this.setState({ currentStage: stage });
  }

  setView(view) {
    this.setState({ view });
  }

  hasPipelinePilotOrganization (orgs) {
    return orgs.filter(org => org.pipeline_pilot).length > 0;
  }

  getOrgs() {
    let url = document.location.origin + "/wp-json/bmp/v1/pipeline/organizations";
    const {portfolio} = this.state;
    if (portfolio) {
      url += "?portfolio=" + portfolio.id;
    }
    axios.get(url)
    .then( res => {
      this.setState({orgs: res.data});
    })
  }

  componentDidMount () {
    this.getOrgs();
  }

  handleOnSelectPortfolio (portfolio) {
    this.setState({ portfolio }, this.getOrgs);
  }

  render() {
    let { view, currentStage } = this.state;
    // rootUrl

    const {
      stages, orgs, match, basename
    } = this.props;

    if (this.props.headersAreLinks !== 'false') {
      currentStage = (((this.props || {}).match || {}).params || {}).stage || '';
    }

    return (
      <div>
        {(basename === 'pipeline' || basename === 'investments') ? (
          <PipelineFilter
            {...this.props}
            {...{ currentStage }}
            setView={this.setView}
            setCurrentStage={this.setCurrentStage}
            setPortfolio={this.setPorfolio}
            view={view}
            onSelectPortfolio={this.handleOnSelectPortfolio.bind(this)}
            />
            ) : (
              ''
              )}
        <div className={`org-list ${view}`}>
          {Object.keys(stages).map((stage) => {
            const active = stages[stage].slug === currentStage ? true : currentStage === 'all';
            return (
              <div
                key={`${stages[stage].slug}-details`}
                className={`single-pipeline-stage ${active ? 'open' : ''}`}
              >
                <div className="container">
                  {this.props.headersAreLinks === 'true' ? (
                    <Link
                      href={`/${this.props.stages[stage].slug}`}
                      to={!active ? `/${this.props.stages[stage].slug}` : '/'}
                      className={`title ${
                        currentStage === this.props.stages[stage].slug ? 'active' : ''
                      }`}
                    >
                      <h3
                        dangerouslySetInnerHTML={{__html: stages[stage].title}}
                      ></h3>
                      <span
                        className="icon"
                        dangerouslySetInnerHTML={{
                          __html: downCarrot(active ? '#FFFFFF' : '#783c96'),
                        }}
                      />
                    </Link>
                  ) : (
                    <button
                      className="title-bar"
                      onClick={() => {
                        const { currentStage } = this.state;
                        this.setState({
                          currentStage:
                            currentStage !== stages[stage].slug ? stages[stage].slug : '',
                        });
                      }}
                    >
                      <h3>{stages[stage].title}</h3>
                      <span
                        className="icon"
                        dangerouslySetInnerHTML={{
                          __html: downCarrot(active ? '#FFFFFF' : '#783c96'),
                        }}
                      />
                    </button>
                  )}

                  <div className="content">
                    <p>{stages[stage].description}</p>
                    <ul>
                      {this.state.orgs && this.state.orgs
                        .filter(x => x.stage === stages[stage].slug) //&& portfolio=selectedItem
                        .map(x => <OrganizationListItem key={`org-li-${x.url}`} {...x} />)}
                    </ul>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

OrganizationsApp.propTypes = {
  stages: PropTypes.shape({}).isRequired,
  rootUrl: PropTypes.string.isRequired,
  match: PropTypes.shape({}).isRequired,
  basename: PropTypes.string.isRequired,
};

export default OrganizationsApp;
